import { Layout, Menu, Typography, theme } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import type React from "react";
import { useMemo, useState } from "react";
import { COMPETITIONS_APP_BASEURL } from "~app/constants";
import { LogoutButton } from "./componentns/LogoutButton";

const { useToken } = theme;

export const Sidedrawer: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const { token } = useToken();
  const productItems = useMemo(
    () => [
      {
        key: "competition-admin-menu-item",
        label: <Typography.Text strong>Competition Admin</Typography.Text>,
        icon: <i style={{ color: token.colorPrimary }} className="multi-color-icon-competition" />,
        link: COMPETITIONS_APP_BASEURL,
      },
      {
        key: "team-manger-menu-item",
        label: <Typography.Text strong>Team Manager</Typography.Text>,
        icon: <i style={{ color: "#ff0000" }} className="fa-solid fa-users" />,
      },
    ],
    [token]
  );

  return (
    <Layout.Sider
      className="sidedrawer"
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 2,
        borderRight: "1px solid #ccc",
      }}
      collapsedWidth={65}
      width={250}
      trigger={null}
      collapsible
      collapsed={collapsed}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100vh",
        }}
      >
        <div>
          <DefaultButton
            type="text"
            size="large"
            icon={collapsed ? <i className="fa-solid fa-bars" /> : <i className="fa-solid fa-xmark" />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              marginLeft: "13px",
              marginTop: "7px",
            }}
          />
          <Menu
            mode="inline"
            style={{
              marginTop: "20px",
              backgroundColor: "#f2f2f2",
            }}
            onClick={(menuItem) => {
              const redirectLink = productItems.find((x) => x.key === menuItem.key)?.link;
              if (redirectLink) {
                window.location.href = redirectLink;
              }
            }}
            items={productItems}
          ></Menu>
        </div>
        <LogoutButton />
      </div>
    </Layout.Sider>
  );
};
